import { jsx } from "react/jsx-runtime";
import React from "react";
var calendar_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 10V8H6v3h12V8h-2v2h-2V8h-4v2H8zm10 3H6v5h12v-5zM6 6h2V4h2v2h4V4h2v2h4v14H4V6h2z" })];
};
export {
  calendar_default as default
};
